// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArchive = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M56 12V20C56 21.2341 55.2341 22 54 22H10C8.76593 22 8 21.2341 8 20V12C8 10.7659 8.76593 10 10 10H54C55.2341 10 56 10.7659 56 12ZM14.0017 26H49.9983C51.2542 26 52.0237 26.7972 51.9994 28.0529C51.7787 39.465 49.7702 48.0119 48.6937 51.8176C48.2848 53.2635 47.3092 54 45.8066 54H18.1934C16.6908 54 15.7152 53.2635 15.3063 51.8176C14.2298 48.0119 12.2213 39.465 12.0006 28.0529C11.9763 26.7972 12.7458 26 14.0017 26ZM26 39H38C38.617 39 39 38.617 39 38V34C39 33.383 38.617 33 38 33H26C25.383 33 25 33.383 25 34V38C25 38.617 25.383 39 26 39Z" />
    </svg>
  );
};
